<template>
  <div class="gmf-share-modal">
    <div class="gmf-subheader">{{ t('share_modal.title') }}</div>
    <TextArea v-model="commentLink" rows="2" readonly></TextArea>
    <div class="gmf-share-modal-buttons">
      <button @click="copyCommentLink" class="gmf-btn gmf-btn-primary">{{ t('share_modal.copy') }}</button>
      <button @click="closeModal" class="gmf-btn gmf-btn-secondary">{{ t('modal.close') }}</button>
    </div>
  </div>
</template>

<style>
.gmf-modal-body:has(.gmf-share-modal) {
  padding: var(--gmf-p-4);
  width: 100%;
  max-width: 450px;
}

.gmf-share-modal {
  display: flex;
  flex-direction: column;
  gap: var(--gmf-p-3);
}

.gmf-share-modal .gmf-textarea textarea {
  min-height: 0;
  resize: none;
}

.gmf-share-modal-buttons {
  display: flex;
  justify-content: center;
  gap: var(--gmf-p-3);
}
</style>

<script>
import state from '@/state';
import tooltip from '@/utils/tooltip';
import { getLocalizedString } from '@/utils/getLocalizedString';
import TextArea from '@/components/input/TextArea.vue';

export default {
  components: {
    TextArea,
  },
  inject: ['comment', 'closeModal'],
  computed: {
    commentLink() {
      return `${getLocalizedString(state.merchantConfig.baseUrl)}?gmf_action=comment:show(${this.comment.id})`;
    },
  },
  methods: {
    t: state.t,
    async copyCommentLink(ev) {
      try {
        await navigator.clipboard.writeText(this.commentLink);
        tooltip.create({x: ev.pageX, y: ev.pageY}, this.t('share_modal.copied'));
      } catch (error) {
        tooltip.create({x: ev.pageX, y: ev.pageY}, error.message);
      }
    }
  }
}
</script>